"use server";

import { cookies } from "next/headers";
import { createServerAction } from "@/lib/actions/create-server-action";
import { sessionCookieDeletion } from "@/lib/auth/session-cookie-options";
import {
  MEDPLUM_COOKIE_NAME,
  SESSION_CANDIDATE_COOKIE_NAME,
  SESSION_EXPIRED_COOKIE_NAME,
} from "@/lib/auth/session-expired-cookie";

/**
 * Logs out the user from Medplum and clears the session cookies.
 *
 * This runs from whichever route saw the 401, not only from `/logout`, so each delete has to
 * carry the `Path` its set used. Without it a teardown from a deep route expires nothing.
 */
export const clearMedplumCookieAction = createServerAction({
  id: "clear-medplum-cookie",
  description: "Clears the Medplum session cookie to log out the user",
  handler: async () => {
    const cookieStore = await cookies();
    cookieStore.delete(sessionCookieDeletion(MEDPLUM_COOKIE_NAME));
    cookieStore.delete(sessionCookieDeletion(SESSION_EXPIRED_COOKIE_NAME));
    cookieStore.delete(sessionCookieDeletion(SESSION_CANDIDATE_COOKIE_NAME));
    return {};
  },
});
